import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../settings/index';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('partners');

function* loadData(data) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = data.payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { data: dataResult, totalCount, filteredCount } = result.data;

      yield put(
        actions.loadDataSuccess({
          data: dataResult,
          total: totalCount,
          filteredTotal: filteredCount,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
